import React from "react";
import style from "./index.module.scss";
import { Button } from "antd";
import { useHistory } from "react-router-dom";

const successPic = require("./img/success.png");
const failPic = require("./img/fail.png");

interface SignResultProps {
    type: "success" | "fail";
    tip: string;
    signTime?: string;
}

export default function SignResult({ type, tip, signTime }: SignResultProps) {
    const history = useHistory();

    return (
        <div className={style.root}>
            <img src={type === "success" ? successPic : failPic} alt="" />

            <div className={style.tip}>
                {tip}

                {signTime && (
                    <div className={style.time}>签到时间：{signTime}</div>
                )}
            </div>

            <Button
                type="primary"
                onClick={history.goBack}
                className={style.button}>
                返回
            </Button>
        </div>
    );
}
